// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"7677d185","518":"7677d185","670":"7677d185","766":"7677d185","849":"7677d185","893":"7677d185","965":"7677d185"}[chunkId] + ".chunk.css";
};